export const getContentGroupData = state => {
  if (!(state.data && !state.data.pending)) return { contentGroups: [], categories: []}
  const { userId } = state.data.user
  const contentGroups = state.data.contentGroups.filter(contentGroup => {
    return contentGroup.GroupUsers.some(user => user.userId === userId)
  })
  const categories = []
  const assignedIds = {}
  // get array of unique categories from the groups
  contentGroups.forEach(group => {
    group.GroupCategories.forEach(category => {
      if (!assignedIds[category.categoryID]) {
        assignedIds[category.categoryID] = true
        categories.push(category)
      }
    })
  })
  return {contentGroups, categories}
}

/**
 * 
 * @param {Object} state redux state
 * @param {string[]} type the redux action type(s) to check pending requests on
 * @returns {boolean} true if any request exists in the request reducer and is currently pending
 */
export const getHasRequestPending = (state, type) => {
  if (Array.isArray(type)) {
    return type.some(requestType => getHasRequestPending(state, requestType))
  }
  return state.request[type] && state.request[type].pending === true
}

/**
 * The bus request keys for the two live-control calls on an event. Neither one
 * writes `eventStatus` locally -- the new status only arrives on the websocket --
 * so this is the only local signal that an event is being started or stopped.
 */
export const EVENT_START_STOP_REQUESTS = [
  'BUS/http.events.start',
  'BUS/http.events.stop'
]

/**
 * @param {Object} state redux state
 * @param {string} eventID the event to check
 * @returns {boolean} true while a start or stop call for this event is in flight
 */
export const getEventStartStopPending = (state, eventID) => {
  return EVENT_START_STOP_REQUESTS.some(type => {
    const request = state.request[type]
    return getHasRequestPending(state, type) &&
      !!request.req &&
      request.req.eventID === eventID
  })
}

export const getHasRequestError = (state, type) => {
  return state.request[type] &&
    state.request[type].pending === false &&
    state.request[type].error && state.request[type].error.message
}
